import React from 'react';

const ErrorMessage = ({ fieldState }) => {
  return fieldState?.error && <div className="se-text-xs se-text-red-500 se-mt-1.5 bargain-widget-v1-input-field-error-message">{fieldState?.error?.message}</div>;
};

export default ErrorMessage;
